export default __webpack_public_path__ + "static/media/smell.33b45bac.jpg";